import React from "react";
import { Autocomplete, TextField } from "@mui/material";

/** The groups a collection site is in, picked on the site form. */
export const SiteGroupsField = ({ groups, value, onChange, disabled }) => (
  <Autocomplete
    multiple
    size="small"
    disabled={disabled}
    options={groups.map((g) => g.id)}
    getOptionLabel={(id) => groups.find((g) => g.id === id)?.name ?? id}
    value={value}
    onChange={(_, v) => onChange(v)}
    sx={{ mt: 2 }}
    renderInput={(params) => (
      <TextField {...params} variant="filled" label="Site groups" helperText="Reports can filter and summarize by group" />
    )}
  />
);
